module.exports = __webpack_public_path__ + "static/assets/0396c2067abcf559e94e91b9e553c36a.svg";